import './common'
import '../scss/style.scss';

$(window).on('load', () => {
  const link = $(document).find('[data-sizes-link]');
  const headerSticky = $(document).find('[data-header-sticky]');
  const header = $(document).find('[data-header]');
  
  link.on('click', scrollEl);

  function scrollEl(e) {
    e.preventDefault();
    let target = $(e.target).attr('href');
    let partTop = $(target).offset().top;
    let headerHeight = header.height();
    let headerStickyHeight = headerSticky.height();
    
    let headerHeightSum = headerHeight + headerStickyHeight;

    $('html, body').animate({scrollTop: partTop - headerHeightSum + 'px'}, 1000);
  }
});